export const SERVICES = [
    {
        id: 1,
        name: "Home Remodeling with Our Home Remodeling Specialists",
        image: "/images/professionals-thumb.png",
        description: "Our Home remodeling service includes, exterior and interior remodeling."
    },
    { 
        id: 2,
        name: "Exterior Painting using the best quality paint and primer",
        image: "/images/professionals-thumb.png",
        description: "Our Exterior Painting service includes, pressure cleaning, windows recaulcking and surface crack repair as well as primer application."
    },
    {
        id: 3,
        name: "Interior Paiting using the best quality interior paint and primer",
        image: "/images/professionals-thumb.png",
        description: "Our interior painting service includes, baseboards and crown moldings as well as furniture and windows covering."
    },
    {
        id: 4,
        name: "Commercial Service with the best quality materials and estimated timeframe",
        image: "/images/professionals-thumb.png",
        description: "Our commercial services include, furniture moving/covering and debris cleaning at the end of the job!."
    }
];